import { Amplify } from 'aws-amplify';
import { withAuthenticator, Authenticator, ThemeProvider} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
//import './sumaqAmplify-overrides.css'
import { sumaqtTheme } from './Theme.ts';


import {Sidemenu} from './components/sidemenu/Sidemenu.tsx'
import Home from './pages/Home';
import Error from './pages/Error';
import Lecturas from './pages/Lecturas'
import TestLectura from './pages/TestLectura';
import TestLecturaPDF from './pages/TestLecturaPDF.js';
import TestLecturaVideoPinterest from './pages/TestLecturaVideoPinterest.js';

import PublishLecture from './pages/PublishLecture.js';
import PublishLectureAdminX from './pages/PublishLectureAdminX.js';
import Profile from './pages/Profile';
import LecturaResult from './pages/LecturaResult';
import { Outlet } from "react-router-dom";
import Footer from './pages/Footer.js';
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import { motion, useScroll, useSpring } from "framer-motion";
import Botones from './pages/botones.jsx';


import Myprogress from './components/progreso/Myprogress.js';
import GlobalProgress from './components/progreso/GlobalProgress.js';
import TopLectoresGlobal from './components/progreso/TopLectoresGlobal.js';
import FetchLecturas from './components/progreso/FetchLecturas.jsx';
import EstadisticasLectores from './components/progreso/EstadisticasLectores.js';
import EstadisticasLectoresMap from './components/progreso/EstadisticasLectoresMap.tsx';

import EstadisticasLectoresMapDiarioMes from './components/progreso/EstadisticasLectoresMapDiarioMes.tsx';
import EstadisticasLectoresMapEachDay from './components/progreso/EstadisticasLectoresMapEachDay.tsx';




import awsExports from './aws-exports'
Amplify.configure(awsExports)

function Layout({signOut,user}) {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
return (
      <>
        <motion.div className="progress-bar-lecturas" style={{ scaleX }} />
        <Outlet />
        
        <Footer />
        
        <Sidemenu SignOut={signOut} username={user.attributes['preferred_username']===undefined?user.username:user.attributes['preferred_username']}
          zoneinfo={user.attributes['zoneinfo']}
        />
        
      </>
  );
}

function App({signOut, user}) {
  const router = createBrowserRouter([
    {
      element: <Layout signOut={signOut} user={user}/>,
      errorElement: <Error />,
      children: [{
        path: '/',
        element: <Home user={user} signOut={signOut}/>   ,
      },
      {
        path: '/about',
        element: <Botones>About</Botones>
      },{
        path: '/nh',
        element: <h1>About</h1>
      },
      {
        path: '/publishLecture',
        element: <><br></br><PublishLecture user={user}/></> 
      },
      {
        path: '/publishLectureAdminX',
        element: <><br></br><PublishLectureAdminX user={user}/></> 
      },
      {
        path: '/profile',
        element: <Profile currentuser={user}/>
      },
      { 
        path: '/myprogress',
        element: <Myprogress user={user}/>
      },
      {
        path: '/globalprogress',
        element: <EstadisticasLectoresMap user={user}/>

      },
      {
        path: '/globaltoplectores',
        element: <TopLectoresGlobal user={user}/>
      },
      {
        path: '/ProgresoLector2025',
        //element: <FetchLecturas url='https://img-dinoblanco-shs.s3.us-east-1.amazonaws.com/c/r/res_data_toplectores.json' provParam={user.attributes['zoneinfo']}/>
        element: <FetchLecturas url='https://img-dinoblanco-shs.s3.us-east-1.amazonaws.com/c/r/res_data_toplectores.json' provParam={user.attributes['zoneinfo']}/>
      },
      {
        path: '/estadisticaslectores',
        element: <EstadisticasLectoresMapEachDay user={user}/>
      },
      {
        path: '/estadisticaslectoresmap',
        element: <EstadisticasLectoresMap user={user}/>
      },
      {
        path: '/estadisticaslectoresmap1',
        element: <EstadisticasLectoresMapDiarioMes user={user}/>
      },
      {
        path: '/estadisticaslectoresmap2',
        element: <EstadisticasLectoresMapEachDay />
      },
      {
        path: '/inicio',
        element: <Sidemenu SignOut={signOut} username={user.username} zoneinfo={user.attributes['zoneinfo']}/> 
      },
      {
        path: '/lecturas',
        element: <> <Lecturas user={user} signOut={signOut}/>  </> ,
        children: [{
          path: '/lecturas/:lecturaid',
          element: <TestLectura user={user} ></TestLectura>
        },{
          path: '/lecturas/n/:lecturaid',
          element: <TestLecturaPDF user={user} ></TestLecturaPDF>
        },{
          path: '/lecturas/vp/:lecturaid',
          element: <TestLecturaVideoPinterest user={user} ></TestLecturaVideoPinterest>
        },{
          path: '/lecturas/resultado/:lecturaresultid/:points',
          element: <LecturaResult user={user} ></LecturaResult>
        }]
      }]
    }
  ])

  return (
        <RouterProvider router={router}></RouterProvider>   
    );
}


/* export default withAuthenticator(
  
    App  
 , {
  hideSignUp: true,
  components: {
    Header() {
      return <h2>SUMAQTAI — Acceso Docente</h2>;
    },
    Footer() {
      return <small>© 2026 SumaqtAI</small>;
    },
  },
} 



)*/

export default    withAuthenticator(App); 
